// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cca4c8a8","968":"81276cd2"}[chunkId] + ".chunk.js";
};